'use client'

import { useTenant } from '@/hooks/useTenant'
import { formatCurrency } from '@/lib/currency/format-currency'

export function usePriceFormatter() {
  const tenant = useTenant()

  const formatPrice = (amount: number | `${number}`) => {
    return formatCurrency(amount, tenant.currency, tenant.locale)
  }

  return {
    formatPrice,
  }
}
